const inquiry = {
  requestProduct: 'Request product',
  from: 'from',
  packSize: 'pack size',
  check: 'You can inquire about the price and availability of the item by phone or using our form in your <b>{pharmacyName}</b>.',
  inquiryForm: 'Inquiry form',
  promise: '<strong>Our promise:</strong> We only use the phone number for any questions the pharmacy may have about your pre-orders. You will also be informed of the status of your order by SMS and email.',
  fillMandatory: '* Please fill out the mandatory fields',
  sendInquiry: 'Send inquiry',
  submitError: 'Your request could not be sent.',
  submitSuccess: 'Your request was successfully sent to the pharmacy.',
  policy: {
    termsOfUse: 'Terms of Use',
    privacyPolicy: 'Privacy Policy',
    1: 'The',
    2: 'and',
    3: 'I have taken note of it and agree with its validity.*',
  },
}

export default inquiry
